<template>
    <v-data-table
        :headers="headers"
        :items="articles"
        hide-actions
        :loading="isLoading"
        class="elevation-1">
        <template slot="items" slot-scope="props">
            <td>{{ props.item.article.article_invoice_short }}</td>
            <td class="text-xs-right">{{ getArticleTypeName(props.item.article.additional.FK_ArticleType) }}</td>
            <td class="text-xs-center">{{ props.item.Menge }}</td>
            <td class="text-xs-right">{{ props.item.article.article_price_netto | currency }}</td>
            <td class="text-xs-right">{{ props.item.article.article_price_netto * props.item.Menge | currency }}</td>
        </template>
        <template v-slot:footer class="">
            <td :colspan="headers.length - 1" class="sum-row">
                <strong>Sum:</strong>
            </td>
            <td class="text-xs-right sum-row" >
                <strong>{{ orderNettoSum | currency }}</strong>
               
            </td>
        </template>
    </v-data-table>
</template>

<script>
import { mapGetters } from "vuex"
import formatter from '@/helpers/formatter'

export default {
    props: {
        orderId: {
            type: Number,
            //  required: true
        }
    },
    components: {},
    data() {
        return {
            formatter,
            tab: 'tab-settings',
            isLoading: false,
            headers: [
                {
                    text: 'Articlename',
                    align: 'left',
                    sortable: true,
                    value: 'article_invoice_short'
                },
                {
                    text: 'Type',
                    align: 'right',
                    sortable: true,
                    value: 'FK_ArticleType'
                },
                {
                    text: 'Amount',
                    value: 'Menge',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Price',
                    value: 'Preis',
                    sortable: false,
                    align: 'right'

                },
                {
                    text: 'Total',
                    value: 'PreisTotal',
                    sortable: false,
                    align: 'right'

                }

            ],
            articles: []
        }
    },
    computed: {
        ...mapGetters([
            'orders',
            'articleTypes'
        ]),
        orderNettoSum () {
            return this.articles
                .map(order => order.article.article_price_netto * order.Menge)
                .reduce((a, b) => a + b, 0)

            // console.log(c)

        }
    },
    methods: {
        close () {
            this.$emit('close')
        },
        getArticleTypeName (articleTypeId) {
            return this.articleTypes.find(i => i.id === articleTypeId).Name
        }
    },
    watch: {
        order: function (value) {
           
        
        }
    },
    created() {

    },
    mounted () {
        this.isLoading = true
        this.$store.dispatch('getOrderArticles', this.orderId)
                .then(articles => this.articles = articles)
                .then(() => this.isLoading = false)
    }
}
</script>
<style lang="scss">
@import '@/assets/scss/_app.variables.scss';

    .sum-row {
        background: $primary;
        color: #fff !important;
        font-size: 16px !important;
    }
</style>
